import React from 'react'
import type { BlogPostFragment, PublicCategory } from 'apollo-gql'
import { useTranslation } from 'lib/i18n'

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'

import styles from './BlogBreadcrumbs.module.css'

type BlogBreadcrumbsProps = {
  blogPost?: BlogPostFragment['blogPost']
  category?: Pick<PublicCategory, 'title' | 'slug'>
}

const BlogBreadcrumbs = ({
  blogPost,
  category,
}: BlogBreadcrumbsProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className={styles.breadcrumbsWrapper}>
      <Breadcrumbs
        items={[
          {
            key: 'startpage',
            href: '/',
            as: '',
            title: t('blogBreadcrumbs.startPage', 'Startpage'),
          },
          {
            key: 'blog',
            href: '/blog',
            as: '/blog',
            title: t('blogBreadcrumbs.blogPage', 'Blog'),
          },
          category && {
            key: 'category',
            href: `/blog/${category.slug}`,
            title: category.title,
            dataCy: 'category',
          },
          blogPost && {
            key: 'blogPost',
            href: `/blog/${blogPost.slug}`,
            title: blogPost.content.title,
          },
        ].filter(Boolean)}
      />
    </div>
  )
}

export default BlogBreadcrumbs
